import React from 'react';
import ONCRP_TOOLS_QP_Card from './OncoRiskCard';
import { KeyValue } from './CommonComponents';

const DatabaseAnnotationsCard = ({ clinVarAnnotations, associatedDiseases }) => {
    if (!clinVarAnnotations && !associatedDiseases) return null;

    return (
        <ONCRP_TOOLS_QP_Card title="Detailed Database Annotations" icon="fa-book-medical" className="ONCRP-TOOLS-QP-span-col-6">
            {clinVarAnnotations?.map((cva, i) => (
                <div key={i} className="ONCRP-TOOLS-QP-section">
                    <h4>ClinVar Annotation: {cva.name}</h4>
                    <div className="ONCRP-TOOLS-QP-kv-grid two-column-grid">
                        <KeyValue label="Significance">{cva.fields.CLNSIG}</KeyValue>
                        <KeyValue label="Review Status">{cva.fields.CLNREVSTAT}</KeyValue>
                        <KeyValue label="Significance Conflict">{cva.fields.CLNSIGCONF}</KeyValue>
                        <KeyValue label="Oncogenicity (ONC) / Somatic (SCI)">{`${cva.fields.ONC} / ${cva.fields.SCI}`}</KeyValue>
                        <KeyValue label="Reported Diseases (CLNDN)">{cva.fields.CLNDN?.replace(/\|/g, ', ')}</KeyValue>
                        <KeyValue label="Disease DBs (CLNDISDB)"><div className="long-text-container">{cva.fields.CLNDISDB}</div></KeyValue>
                    </div>
                </div>
            ))}
            {associatedDiseases && (
                <div className="ONCRP-TOOLS-QP-section">
                    <h4>Full Associated Diseases List</h4>
                    <div className="ONCRP-TOOLS-QP-tags-container">
                        {[...new Set(associatedDiseases)].map((disease, i) => (
                            <span key={i} className="ONCRP-TOOLS-QP-tag ONCRP-TOOLS-QP-tag-disease">{disease}</span>
                        ))}
                    </div>
                </div>
            )}
        </ONCRP_TOOLS_QP_Card>
    );
};

export default DatabaseAnnotationsCard; 